<div class="container-fluid">
  <form [formGroup]="form1">
    <mat-tab-group>
      <mat-tab label="Project">
        <div class="row">
          <div class="col-lg-4 col-md-6">
            <mat-card class="row">
              <div class="col-lg-12">
                <mat-card-header>
                  <mat-card-title>Project Call</mat-card-title>
                </mat-card-header>
              </div>
              <div class="col-lg-12">
                <mat-card-content>
                </mat-card-content>
              </div>
            </mat-card>
          </div>



          <div class="col-lg-4 col-md-6">
            <mat-card>
              <mat-card-header>
                <mat-card-title>Status</mat-card-title>
              </mat-card-header>
              <mat-card-content> <br>
                <mat-accordion>
                  <mat-expansion-panel [expanded]="false">
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        <mat-icon style="color:green; font-size:140%">add_circle</mat-icon>Categorize
                      </mat-panel-title>
                      <mat-panel-description>
                      </mat-panel-description>
                    </mat-expansion-panel-header>
                    <app-task-reservation-select [taskApi]="taskApi"> </app-task-reservation-select>

                    <app-property-select [taskId]="form1.get('taskId').value" [shortTermRentalId]="" (messageEvent)="setShortTermRentalId($event)">
                    </app-property-select>
                    <app-tag-join-select [tagSource]="30" [tagSourceId]="form1.get('taskId').value" tagType="4" (messageEvent)="setAssignedToTagId($event)"></app-tag-join-select>
                    <app-tag-dd-select [tagSource]="30" [tagSourceId]="taskId" tagType="1" (messageEvent)="setAssignedToTagId($event)"></app-tag-dd-select>
                    <app-tag-dd-select [tagSource]="30" [tagSourceId]="form1.get('taskId').value" tagType="2" (messageEvent)="setAssignedToTagId($event)"></app-tag-dd-select>
                    <app-tag-dd-select [tagSource]="30" [tagSourceId]="form1.get('taskId').value" tagType="3" (messageEvent)="setAssignedToTagId($event)"></app-tag-dd-select>
                    <app-tag-dd-select [tagSource]="30" [tagSourceId]="form1.get('taskId').value" tagType="5" (messageEvent)="setAssignedToTagId($event)"></app-tag-dd-select>
                    <app-tag-dd-select [tagSource]="30" [tagSourceId]="form1.get('taskId').value" tagType="6" (messageEvent)="setAssignedToTagId($event)"></app-tag-dd-select>
                    <app-tag-dd-select [tagSource]="30" [tagSourceId]="form1.get('taskId').value" tagType="7" (messageEvent)="setAssignedToTagId($event)"></app-tag-dd-select>
                  </mat-expansion-panel>
                </mat-accordion> <br>
                <mat-accordion>
                  <mat-expansion-panel [expanded]="false">
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        <mat-icon style="color:green; font-size:140%">add_circle</mat-icon>Repeat @if (this.intervalTaskRepeat&&this.intervalTaskRepeat.frequency!=0) {
                        <span
                        style="color:green; border:1px solid lightgrey">&nbsp;[On]&nbsp;</span>
                      }
                    </mat-panel-title>
                    <mat-panel-description> </mat-panel-description>
                  </mat-expansion-panel-header>
                  <app-interval-select [taskId]="form1.get('taskId').value" [interval]="this.intervalTaskRepeat" intervalType="1" (messageEvent)="setAssignedToTagId($event)">
                  </app-interval-select>
                </mat-expansion-panel>
              </mat-accordion>
            </mat-card-content>
          </mat-card>
        </div>




        <div class="col-lg-4 col-md-6">
          <mat-card>
            <mat-card-header>
              <mat-card-title>Summary</mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <table style="white-space: nowrap">
                @if (form1.get('taskId').value !== undefined) {
                  <tr>
                    <td>Task Id:</td>
                    <td>{{form1.get('taskId').value}}</td>
                  </tr>
                }
                @if (this.taskApi !== undefined  && this.taskApi.createdBy !== undefined) {
                  <tr>
                    <td>Created:</td>
                    <td>{{this.taskApi.dateCreated | date:'short' }}</td>
                    <td>by {{this.taskApi.createdBy.firstName}} {{this.taskApi.createdBy.lastName}}</td>
                  </tr>
                }
                @if (this.taskApi !== undefined  && this.taskApi.dateStart !== undefined) {
                  <tr>
                    <td>Begin:</td>
                    <td>{{this.taskApi.dateStart | date:'short' }}</td>
                  </tr>
                }
                @if (this.taskApi !== undefined  && this.taskApi.dateEnd !== undefined) {
                  <tr>
                    <td>End:</td>
                    <td>{{this.taskApi.dateEnd | date:'short' }}</td>
                  </tr>
                }
                @if (this.taskApi !== undefined  && this.taskApi.dateLastUpdated !== undefined) {
                  <tr>
                    <td>Last Updated:</td>
                    <td>{{this.taskApi.dateLastUpdated | date:'short' }}</td>
                  </tr>
                }
                @if (this.taskApi !== undefined  && this.taskApi.assignedTo !== undefined) {
                  <tr>
                    <td>Assigned:</td>
                    <td>{{this.taskApi.dateAssigned | date:'short' }}</td>
                  </tr>
                }
              </table>
            </mat-card-content>
          </mat-card>
        </div>
      </div>
    </mat-tab>

    <mat-tab label="miniDoc">
      <!-- <ckeditor [editor]="editor" formControlName="miniDoc" data="<p>KBM Hawaii</p>" (ready)="onReady($event)"></ckeditor> -->
      <editor
        formControlName="miniDoc"
						[init]="{
							height: 500,
							base_url: '/tinymce',
							suffix: '.min',
							plugins: 'code anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount',
      toolbar: 'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table | align lineheight | numlist bullist indent outdent | emoticons charmap | removeformat'}" >
      </editor>
    </mat-tab>


  </mat-tab-group>
</form>
</div>